import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=fafab222&"
import script from "./deposit.vue?vue&type=script&lang=ts&"
export * from "./deposit.vue?vue&type=script&lang=ts&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=fafab222&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports